import React from 'react';
import styles from './customer.module.scss';
import CardForm from '../form/cardForm';
export default function PublicForm({formData}) {
  return (
    <div className={styles.wrapper}>
      <CardForm/>
    </div>
  );
}
